module.exports = __webpack_public_path__ + "img/H2.32b87cda.png";